<!-- Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. -->

<div>
  @if (label) {
    <label [attr.for]="id" class="select-label" [xdaTranslate]="label"></label>
  }
  @if (label) {
    <br />
  }
  <div
    ngbDropdown
    class="bootstrap-select dropdown dropdown-block"
    [id]="id"
    [placement]="placement"
    [ngClass]="{ 'is-invalid': isErrorState() }"
    [ngStyle]="{ 'min-width': dropdownMinWidth }">
    <button
      type="button"
      class="xrx-btn dropdown-toggle btn-secondary"
      [ngClass]="{ btn: isMfd, medium: isMfd }"
      [id]="id"
      ngbDropdownToggle>
      @if (
        selectedItem &&
        ($any(selectedItem).glyph || $any(selectedItem)?.icon?.image)
      ) {
        <span class="filter-option">
          @if ($any(selectedItem).glyph) {
            <i [ngClass]="$any(selectedItem).glyph"></i>
          }
          @if ($any(selectedItem).icon?.image) {
            <img [src]="$any(selectedItem).icon.image" />
          }
          <span
            class="filter-option-label"
            [xdaTranslate]="getPropertyString('localize', selectedItem)"></span>
        </span>
      }
      @if (!selectedItem) {
        <span class="filter-option" [xdaTranslate]="inlineLabel"></span>
      }
      @if (
        selectedItem &&
        !$any(selectedItem).glyph &&
        !$any(selectedItem).icon?.image
      ) {
        <span
          class="filter-option"
          [xdaTranslate]="getPropertyString('localize', selectedItem)"></span>
      }
      <span class="select-btn-caret"
        ><i class="caret xgl-navigate_down" [ngClass]="{ mfd: isMfd }"></i
      ></span>
    </button>
    @if (isErrorState()) {
      <div class="invalid-feedback">
        @if (required && !error) {
          <div [xdaTranslate]="'SDE_REQUIRED_FIELD1'"></div>
        }
        @if (error) {
          <div [xdaTranslate]="error"></div>
        }
      </div>
    }
    @if (type != 'group') {
      <div
        [attr.aria-labelledby]="id"
        class="dropdown-menu select-dropdown"
        ngbDropdownMenu>
        @if (sort) {
          <div>
            @for (item of list | orderBy: dir : orderby; track item) {
              <div
                (click)="selectItem(item)"
                [ngClass]="{
                  selected:
                    selectedItem &&
                    item[property] ===
                      getPropertyString('property', selectedItem),
                }"
                ngbDropdownItem>
                @if (item.glyph) {
                  <span [ngClass]="item.glyph"></span>
                }
                @if ($any(item.icon)?.image) {
                  <img [src]="$any(item.icon).image" />
                }
                <span
                  [xdaTranslate]="getPropertyString('localize', item)"></span>
              </div>
            }
          </div>
        }
        @if (!sort) {
          <div>
            @for (item of list; track item) {
              <div
                (click)="selectItem(item)"
                [ngClass]="{
                  selected:
                    selectedItem &&
                    getPropertyString('property', item) ===
                      getPropertyString('property', selectedItem),
                }"
                ngbDropdownItem>
                @if ($any(item).glyph) {
                  <span [ngClass]="$any(item).glyph"></span>
                }
                @if ($any(item).icon?.image) {
                  <img [src]="$any(item).icon.image" />
                }
                <span
                  [xdaTranslate]="getPropertyString('localize', item)"></span>
              </div>
            }
          </div>
        }
      </div>
    }
    @if (type == 'group') {
      <div
        [attr.aria-labelledby]="id"
        class="dropdown-menu select-dropdown"
        ngbDropdownMenu>
        @for (group of list; track group; let isLast = $last) {
          <div>
            @if ($any(group).title) {
              <span
                class="dropdown-header"
                [xdaTranslate]="$any(group).title"></span>
            }
            @for (
              item of $any(group).options | orderBy: dir : orderby;
              track item
            ) {
              <div
                (click)="selectItem(item)"
                [ngClass]="{
                  selected:
                    selectedItem &&
                    item[property] ===
                      getPropertyString('property', selectedItem),
                }"
                ngbDropdownItem>
                <span
                  [xdaTranslate]="getPropertyString('localize', item)"
                  [ngClass]="{ opt: $any(group).title }"></span>
              </div>
            }
            @if (!isLast) {
              <div class="dropdown-divider"></div>
            }
          </div>
        }
      </div>
    }
  </div>
</div>
